import React from 'react'
import PropTypes from 'prop-types'
import { useField, ErrorMessage } from 'formik'

// Styled Elements
import { FormInputWrapper, FormLabel, FormTextAreaInput, FormErrorMessage } from './FormTextArea.elements'

function FormTextArea(props) {
  // Destructure
  const { type, label, resize, disabled, ...rest } = props

  // Hooks
  const [fields] = useField(props)

  return (
    <FormInputWrapper label={label}>
      {label && <FormLabel disabled={disabled}>{label}</FormLabel>}
      <FormTextAreaInput disabled={disabled} type={type} resize={resize} {...fields} {...rest} />
      <FormErrorMessage>
        <ErrorMessage {...fields} />
      </FormErrorMessage>
    </FormInputWrapper>
  )
}

// Default Props
FormTextArea.defaultProps = {
  type: '',
  label: '',
  resize: true,
  disabled: false,
}

// Proptypes Validation
FormTextArea.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  resize: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default FormTextArea
